export * from './text-inline-image'
